import React from 'react'
import './EditAmenities.scss'
import PropTypes from 'prop-types'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import CancelIcon from '@material-ui/icons/Cancel'
import DoneIcon from '@material-ui/icons/Done'
import AddIcon from '@material-ui/icons/Add'
import ClearIcon from '@material-ui/icons/Clear'
import { withStyles } from '@material-ui/core/styles'
import EditIcon from '@material-ui/icons/Edit'
import { EditDisclaimeText } from '@components/common'

const styles = {
  dialogPaper: {
    minHeight: '330px',
    minWidth: '800px'
  },
  root: {
    backgroundColor: '#eaeaea',
    justifyContent: 'start'
  }
}
export class EditAmenities extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      amenities: props.amenities || [],
      editAmenitie: '',
      selectedIndexToUpdate: -1,
      form: false,
      disclaimerForm: false,
      showDisclaimer: props.showDisclaimer === undefined ? true : Boolean(props.showDisclaimer),
      disclaimerText: props.disclaimerText
    }
  }

  componentDidUpdate = prevProps => {
    if ((prevProps.amenities !== this.props.amenities)) {
      this.setState({
        amenities: this.props.amenities
      })
    }
  }

  handleFormClear = () => {
    this.setState({ form: false })
  }

  resetAmenitiesDialog = () => {
    this.setState({
      amenities: this.props.amenities || [],
      editAmenitie: '',
      form: false,
      disclaimerForm: false,
      showDisclaimer: this.props.showDisclaimer,
      disclaimerText: this.props.disclaimerText
    }, this.props.handleAmenitiesDialog)
  }

  handlesSaveAmenities = () => {
    this.props.editPropertyData({ amenities: this.state.amenities, showDisclaimer: this.state.showDisclaimer, disclaimerText: this.state.disclaimerText })
    this.props.handleAmenitiesDialog()
  }

  updateAmenity = event => {
    event.preventDefault()
    const amenitiesList = [...this.state.amenities]
    if (this.state.selectedIndexToUpdate !== -1) {
      amenitiesList.splice(this.state.selectedIndexToUpdate, 1, event.target.amenitie.value)
    } else {
      amenitiesList.push(event.target.amenitie.value)
    }
    this.setState({
      form: false,
      editAmenitie: '',
      selectedIndexToUpdate: -1,
      amenities: amenitiesList
    })
  }

  handleEditAmenities = (amenitie, index) => {
    if (!this.state.form && !this.state.disclaimerForm) {
      this.setState({
        editAmenitie: amenitie,
        selectedIndexToUpdate: index,
        form: true
      })
    }
  }

  handleDeleteAmenities = deleteIndex => {
    const amenitiesList = [...this.state.amenities]
    amenitiesList.splice(deleteIndex, 1)
    this.setState({
      amenities: amenitiesList
    })
  }

  editDisclaimerText = () => {
    if (!this.state.disclaimerForm) {
      this.setState({
        form: false,
        disclaimerForm: true
      })
    }
  }

  handleShowDisclaimer = () => {
    this.setState({
      showDisclaimer: !this.state.showDisclaimer
    })
  }

  updateDisclaimerText = event => {
    event.preventDefault()
    this.setState({
      form: false,
      disclaimerForm: false,
      disclaimerText: event.target.disclaimerText.value
    })
  }

  cancelDisclaimerText = () => {
    this.setState({
      form: false,
      disclaimerForm: false,
      disclaimerText: this.props.disclaimerText
    })
  }

  render() {
    const { dialog,
            chunk,
            classes,
            amenitiesCount
          } = this.props

    const { form,
            disclaimerForm,
            disclaimerText,
            showDisclaimer,
            editAmenitie
          } = this.state

    const { updateAmenity,
            handleEditAmenities,
            handleDeleteAmenities,
            handlesSaveAmenities,
            handleFormClear,
            editDisclaimerText,
            updateDisclaimerText,
            cancelDisclaimerText,
            handleShowDisclaimer
          } = this
          const amenitiesInGrpDialog = chunk(4, this.state.amenities)

    return (
        <Dialog
          data-testid="amenities_edit_dialog"
          classes={{ paper: classes.dialogPaper }}
          open={dialog}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent>
            <div>
              {amenitiesInGrpDialog &&
                amenitiesInGrpDialog.map((list, i) => (
                  <div key={i} className="editamenities__list_dialog">
                    <ul className="editamenities__wrap">
                      {list.map((amenitie, j) => (
                        i < 10 ?
                        <li key={j}>
                          <div className="editamenities__chip">
                            <span
                              data-testid={`amenities_dialog_edit_${amenitie}`}
                              onClick={() => handleEditAmenities(amenitie, (4 * i) + j)}
                              className="editamenities__chip_info"
                            >
                              {amenitie.trim()}
                            </span>
                            <CancelIcon
                              data-testid={`amenities_dialog_del_${amenitie}`}
                              onClick={() => handleDeleteAmenities((4 * i) + j)}
                              className="editamenities__del_chip_icon"
                            />
                          </div>
                        </li> : ''
                      ))}
                    </ul>
                  </div>
                ))}
                <div className="disclaimer_text">
                  <span className="add_disclaimer_text">{(disclaimerText && disclaimerText.trim()) ? disclaimerText : '+ Add Disclaimer text'}</span>
                <div
                  onClick={editDisclaimerText}
                  data-testid="add_disclaimer_edit"
                  className="editamenities__edit_icon"
                >
                  <EditIcon className="editamenities__editpen" />
                </div>
                </div>
            </div>
          </DialogContent>
          <DialogActions classes={{ root: classes.root }}>
            {!form && !disclaimerForm && (
              <div className="editamenities__actions">
                <div className="editamenities__actions_add_msg">
                  <Button
                    data-testid="amenities__actions_add"
                    id="amenities__actions_add"
                    disabled={this.state.amenities.length >= amenitiesCount}
                    onClick={() => handleEditAmenities('', -1)}
                    color="secondary"
                  >
                    <AddIcon />
                    Add
                  </Button>
                  {this.state.amenities.length >= amenitiesCount && <div className="editamenities__actions_warning_msg">Amenities reached the maximum template limit</div>}
                </div>
                <div>
                  <Button
                    data-testid="amenities__actions_cancel"
                    id="amenities__actions_cancel"
                    onClick={() => this.resetAmenitiesDialog()}
                    color="secondary"
                  >
                    Cancel
                  </Button>
                  <Button
                    data-testid="amenities__actions_done"
                    id="amenities__actions_done"
                    onClick={() => handlesSaveAmenities()}
                    color="secondary"
                  >
                    <DoneIcon />
                    Done
                  </Button>
                </div>
              </div>
            )}
            {form && (
              <div className="editamenities__actions_form">
                <form
                  name="form_edit"
                  data-testid="amenities_edit_dialog_form"
                  className="editamenities__action_formblock"
                  onSubmit={updateAmenity}
                >
                  <TextField
                    autoFocus
                    margin="dense"
                    name="amenitie"
                    defaultValue={editAmenitie}
                    type="text"
                    fullWidth
                    inputProps={{ 'data-testid': 'amenities__texttoupdate' }}
                  />
                  <div className="editamenities__form_btn">
                    <ClearIcon
                      data-testid="amenities__actions_clear"
                      id="amenities__actions_clear"
                      onClick={handleFormClear}
                    />
                    <Button
                      data-testid="amenities__actions_submit"
                      type="submit"
                      id="amenities__actions_check"
                      color="primary"
                    >
                      <DoneIcon />
                    </Button>
                  </div>
                </form>
              </div>
            )}
            {disclaimerForm && (
              <EditDisclaimeText
                disclaimerText={disclaimerText}
                updateDisclaimerText={updateDisclaimerText}
                cancelDisclaimerText={cancelDisclaimerText}
                showDisclaimer={showDisclaimer}
                handleShowDisclaimer={handleShowDisclaimer}
                defaultDisclaimerText="* Select Units"
              />
            )}
          </DialogActions>
        </Dialog>
    )
  }
}

EditAmenities.propTypes = {
  showDisclaimer: PropTypes.bool,
  disclaimerText: PropTypes.string,
  classes: PropTypes.object,
  amenitiesCount: PropTypes.number,
  dialog: PropTypes.bool,
  amenities: PropTypes.array,
  chunk: PropTypes.func,
  handleAmenitiesDialog: PropTypes.func,
  editPropertyData: PropTypes.func
}

export default withStyles(styles)(EditAmenities)


